import { BIBLIOTECA } from "@/lib/senales";
import { FORMATOS } from "@/lib/carteles";
import { EscudoCartel } from "@/components/carteles/CartelEditor";

export const PX_MM = 96 / 25.4;

// Un cartel de plantilla a tamaño real (mm); `k` escala de A4 a A3. datos.senal === false: sin la señal (solo texto)
export const Cartel = ({ tpl, datos, formato, ine }) => {
  const f = FORMATOS[formato];
  const mm = (v) => `${v * f.k}mm`;
  const Senal = datos.senal === false ? null : BIBLIOTECA[tpl.senal(datos)]?.C;
  // sin la señal, la prohibición tiene que ir escrita (la plantilla «Desde una hora» la confía a la R-307)
  const dest = tpl.destacado?.(datos) || (datos.senal === false && tpl.grupo === "vallas" ? "PROHIBIDO PARAR Y ESTACIONAR" : null);
  // con línea destacada la señal se reduce para dejar sitio al texto; sin señal, el texto gana tamaño
  const grande = !Senal;
  return (
    <div className="cartel bg-white text-black flex flex-col items-center justify-between text-center relative"
      style={{ width: `${f.w}mm`, height: `${f.h}mm`, padding: `${mm(dest ? 12 : 16)} ${mm(22)} ${mm(dest ? 14 : 20)}`, fontFamily: "Arial, Helvetica, sans-serif", boxSizing: "border-box" }}
      data-testid="cartel">
      <EscudoCartel ine={ine} k={f.k} />
      <div style={{ fontSize: `${(dest ? 22 : 26) * f.k}pt`, lineHeight: 1.15 }}>{tpl.titulo(datos)}</div>
      {Senal && <div style={{ width: mm(dest ? 82 : 118), height: mm(dest ? 82 : 118) }}><Senal /></div>}
      {dest && <div style={{ fontSize: `${(grande ? 44 : 30) * f.k}pt`, lineHeight: 1.1, fontWeight: 800, color: "#b00000" }}>{dest}</div>}
      <div style={{ fontSize: `${(grande ? 32 : dest ? 20 : 26) * f.k}pt`, lineHeight: 1.25, maxWidth: "100%" }}>{tpl.texto(datos)}</div>
    </div>
  );
};
